import { render, staticRenderFns } from "./coupon_edit.vue?vue&type=template&id=400530c2&scoped=true"
import script from "./coupon_edit.vue?vue&type=script&lang=js"
export * from "./coupon_edit.vue?vue&type=script&lang=js"
import style0 from "./coupon_edit.vue?vue&type=style&index=0&id=400530c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400530c2",
  null
  
)

export default component.exports